import { render, staticRenderFns } from "./TrainBotModal.vue?vue&type=template&id=c21b9dec&"
import script from "./TrainBotModal.vue?vue&type=script&lang=js&"
export * from "./TrainBotModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports